module.exports = __webpack_public_path__ + "static/img/m2_t2b.dfad21bc.jpg";